/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  productVariantsTranslationsEn,
  productVariantsTranslationsEs
} from '@spartacus/product/variants/assets';
import {
  PRODUCT_VARIANTS_FEATURE,
  ProductVariantsRootModule,
} from '@spartacus/product/variants/root';

@NgModule({
  imports: [ProductVariantsRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [PRODUCT_VARIANTS_FEATURE]: {
          module: () =>
            import('@spartacus/product/variants').then(
              (m) => m.ProductVariantsModule
            ),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources:{
          en:{ productVariants: productVariantsTranslationsEn },
          es:{ productVariants: productVariantsTranslationsEs }
        }
      },
    }),
  ],
})
export class VariantsFeatureModule { }
